/**
 * Created by wupeng on 2019/8/9.
 */
import { service, fileService } from '@/data/index';
/**
 * @function getPersonList 获取人员列表
 * @param data  人员查询参数对象{}
 * @returns {*}
 */

export function getPersonList(data) {
  return service.post('org/person/findAll', data);
}
/**
 * @function getPersonInfo 获取单个人员信息
 * @param data  人员查询参数对象{}
 * @returns {*}
 */

export function getPersonInfo(data) {
  return service.post('org/person/detail', data);
}
/**
 * @function getAdminCenterDetail 个人中心-人员获取个人用户信息
 * @returns {*}
 */

export function getAdminCenterDetail() {
  return service.post('/org/person/detailSelf');
}
/**
 * @function addPerson 新增人员
 * @param data  人员信息参数对象{}
 * @returns {*}
 */

export function addPerson(data) {
  return service.post('org/person/save', data);
}
/**
 * @function editPerson 人员修改
 * @param data  人员信息参数对象{}
 * @returns {*}
 */

export function editPerson(data) {
  return service.post('org/person/update', data);
}
/**
 * @function resetPersonPwd 批量重置密码
 * @param data  参数对象{ids: '11,22'}
 * @returns {*}
 */

export function resetPersonPwd(data) {
  return service.post('school/userOrgPerson/updatePassword', data);
}
/**
 * @function multiDeletePerson 批量删除人员信息
 * @param data  参数对象{ids: '11,22'}
 * @returns {*}
 */

export function multiDeletePerson(data) {
  return service.post('org/person/deleteBatch', data);
}
/**
 * @function importPersonFile 人员信息批量导入
 * @param data  参数对象{}
 * @returns {*}
 */

export function importPersonFile(data) {
  return fileService.post('org/person/import', data);
}
/**
 * @function getOrderOrgPersonner 用户授权 组织机构与人员关联关系查询
 * @param data
 * @returns {*}
 */

export function getOrderOrgPersonner(data) {
  return service.get('school/schOrg/getOrderOrgPersonner', data);
}
/**
 * 用户授权 人员查询
 * @param data
 */

export function findRegisterPersonner() {
  return service.post('org/person/findRegisterPersonner');
}
/**
 * 用户授权 组织机构与人员新增
 */

export function addOrderPersonner(data) {
  return service.get('school/schOrg/addOrderPersonner', data);
}
/**
 * 用户授权 删除授权教育局人员
 * @param data
 */

export function deleteOrderPersonner(data) {
  return service.get('school/schOrg/deleteOrderPersonner', data);
}